<template>
    <Modal :close_button="true" :size="'modal-md'" mid="confirm-delete-location">
        <template v-slot:header>{{$t('management_console.workplace_modal.delete_title')}}</template>
        <template v-slot:body>
            <p v-if="location">{{$t('management_console.workplace_modal.workplace')}}: <strong>{{location.name}}</strong></p>
            <p><span class="badge bg-danger">{{$t('management_console.workplace_modal.attention')}}</span> {{$t('management_console.workplace_modal.delete_description')}}</p>
            <p>{{$t('management_console.workplace_modal.data_description')}}</p>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-danger bg-gradient px-4" @click="submit()">{{$t('management_console.common.delete')}}</button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import InventoryLocationStore from '@/common/store/inventory_location.js'

export default {
    props: {
        location: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            agree: false
        }
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/confirm-delete-location')
        },
        submit: async function () {
            const response = await InventoryLocationStore.dispatch('DELETE_LOCATION', { location_id: this.location.id })
            if (response.status === 0) {
                this.agree = false
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('management_console.workplace_modal.deleted'), level: 'success' })
                this.$bus.$emit('Modal/hide/confirm-delete-location')
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }
        }
    }
}
</script>
